import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    propertyIndustryList: [],
  },
  getters: {},
  mutations: {
    setPropertyIndustryList(state, data) {
      state.propertyIndustryList = [...data]
    },
  },
  actions: {
    async getPropertyIndustryList({ commit }) {
      let [err, res] = await getPartitioningChild(11)
      if (err) return
      commit('setPropertyIndustryList', res)
    },
  }
}
